/* eslint-disable no-labels */
import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Card,
  CardBody,
  Alert,
  Spinner,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import ListingForm from '../../components/Listing/ListingForm';
import ProfileSelector from '../../components/Profile/ProfileSelector';
import * as url from '../../helpers/url_helper';
import { get } from '../../helpers/api_helper';

// eslint-disable-next-line no-unused-vars
function CreateListingForm(props) {
  const history = useHistory();

  const onSuccess = (lst) => {
    history.push(`/listing/${lst.id}`);
  };

  const [entity, setEntity] = useState({
    attributes: [],
    channels: [],
    devices: [],
    images: [],
    items: [],
    videos: [],
    related: [],
    sku: '',
    title: '',
    brand: '',
    description: '',
  });
  const [profile, setProfile] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [item, setItem] = useState(null);

  const { itemId = null, profileId } = useParams();

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const profileToEntity = (prof, itemObj) => {
    setProfile(prof);
    const p = {};

    p.title = prof.title;
    p.sku = prof.sku;
    p.condition = prof.condition;
    p.brand = prof.brand;
    p.ship_weight = prof.ship_weight;
    p.ship_dims = prof.ship_dims;
    p.devices = [];
    p.images = [];
    p.items = [];
    p.price = 0;
    p.profile_id = prof.id;
    p.description = prof.description;
    p.important = prof.important;

    const replaceShortcodes = (str) => {
      if (str === null) return null;

      let newStr = str;
      const isMatch = newStr.match(/\{([^}]+)\}/g);
      if (isMatch != null) {
        for (let i = 0; i < isMatch.length; i += 1) {
          if (itemObj[isMatch[i].slice(1, -1)] != null) {
            newStr = newStr.replace(
              isMatch[i],
              itemObj[isMatch[i].slice(1, -1)],
            );
          }
        }
      }

      return newStr;
    };

    if (itemObj !== undefined) {
      // Replace shortcodes in listing title
      p.title = replaceShortcodes(p.title);

      // Replace shortcodes in listing sku
      p.sku = replaceShortcodes(p.sku);

      // Replace shortcodes in listing brand
      p.brand = replaceShortcodes(p.brand);

      // Replace shortcodes in listing description
      p.description = replaceShortcodes(p.description);
      p.important = replaceShortcodes(p.important);

      // import images from item
      p.images = [];
      // for (let i = 0; i < itemObj.images.length; i += 1) {
      //   p.images.push({
      //     url: itemObj.images[i].url,
      //     is_default: itemObj.images[i].is_default,
      //     label: itemObj.images[i].label,
      //   });
      // }

      // import devices from item
      p.devices = [];
      for (let i = 0; i < itemObj.devices.length; i += 1) {
        p.devices.push(itemObj.devices[i]);
      }
    }

    // add first item group
    p.items = [
      {
        group: 1,
        item_qty: 1,
        id: itemId !== null ? itemId : null,
        part_number: itemObj !== undefined ? itemObj.part_number : null,
        manufacturer: itemObj !== undefined ? itemObj.manufacturer : null,
        condition: itemObj !== undefined ? itemObj.condition : null,
      },
    ];

    p.tags = [];
    for (let i = 0; i < prof.tags.length; i += 1) {
      p.tags.push(prof.tags[i]);
    }

    p.attributes = [];
    for (let i = 0; i < prof.attributes.length; i += 1) {
      // Replace shortcodes in listing attributes
      p.attributes.push({
        label: prof.attributes[i].label,
        code: replaceShortcodes(prof.attributes[i].code),
      });
    }

    for (let i = 0; i < itemObj.boardNumbers.length; i += 1) {
      for (let x = 0; x < p.attributes.length; x += 1) {
        if (p.attributes[x].label === itemObj.boardNumbers[i].label
          && p.attributes[x].code === null) {
          p.attributes[x].code = itemObj.boardNumbers[i].value;
          break;
        }
      }

      p.attributes.push({
        label: itemObj.boardNumbers[i].label,
        code: itemObj.boardNumbers[i].value,
      });
    }

    p.channels = [];
    for (let i = 0; i < prof.channels.length; i += 1) {
      p.channels.push({
        channel: prof.channels[i].channel,
      });
    }

    p.videos = [];
    for (let i = 0; i < prof.videos.length; i += 1) {
      p.videos.push({
        youtube_id: prof.videos[i].youtube_id,
      });
    }

    p.related = [];

    setEntity(p);
  };

  useEffect(() => {
    const fetchProfileData = async (id, itemObj) => {
      try {
        const profData = await get(url.GET_PROFILE.replace(':id', id));

        profileToEntity(profData, itemObj);
      } catch (e) {
        setError(`${e.message}`);
      }
    };

    const fetchItemData = async () => {
      try {
        const itmData = await get(`${url.GET_ITEM}/${itemId}`);

        setItem(itmData);

        await fetchProfileData(profileId, itmData);
      } catch (e) {
        setError(`${e.message}`);
      } finally {
        setLoading(false);
      }
    };

    if (itemId !== null) {
      setLoading(true);
      fetchItemData();
    }
  }, []);

  return (
    <div className="page-content">
      <div className="container-fluid">
        {error !== null && loading === false && (
          <Alert color="danger">
            {error}
          </Alert>
        )}
        {itemId === null && (
          <>
            <Card className="mb-4">
              <CardBody>
                <ProfileSelector onSelect={profileToEntity} />
              </CardBody>
            </Card>

            {profile === false && (
              <Alert color="warning">
                <span>{props.t('Awaiting profile selection...')}</span>
              </Alert>
            )}
          </>
        )}
        {profile !== false && (
          <ListingForm
            actionUrl={url.POST_LISTING}
            entity={entity}
            onSuccess={onSuccess}
          />
        )}
        {loading === true && (
          <Spinner />
        )}
      </div>
    </div>
  );
}

CreateListingForm.defaultProps = {
  t: (x) => (x),
};

CreateListingForm.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(CreateListingForm));
